module.exports = "<ng-template #popup let-c=\"close\" let-d=\"dismiss\">\r\n  <div class=\"modal-header\">\r\n    <h4 class=\"modal-title\">{{ title | translate }}</h4>\r\n    <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"d('Cross click')\">\r\n      <span aria-hidden=\"true\">&times;</span>\r\n    </button>\r\n  </div>\r\n  <div class=\"modal-body\">\r\n    <ng-content select=\"[popup-body]\"></ng-content>\r\n  </div>\r\n  <div class=\"modal-footer\">\r\n    <ng-content select=\"[popup-footer]\"></ng-content>\r\n  </div>\r\n</ng-template>"


//////////////////
// WEBPACK FOOTER
// ./src/app/+admin/modules/popup/popup.component.html
// module id = 1158
// module chunks = 7